package ru.villawonka.app.presentation.screens.setup.viewmodel

import ru.villawonka.app.common.mvvm.UIState
import ru.villawonka.app.domain.model.NetworkFailure
import ru.villawonka.app.presentation.model.CurrencyUIModel
import ru.villawonka.app.presentation.model.LanguageUIModel
import ru.villawonka.app.presentation.screens.setup.model.CountryButtonUIModel

sealed class SetupUIState : UIState {

    data object Loading : SetupUIState()

    data class Error(val failure: NetworkFailure) : SetupUIState()

    sealed class Step : SetupUIState() {

        data class Language(
            val options: List<LanguageUIModel>
        ) : Step()

        data class Country(
            val options: List<CountryButtonUIModel>
        ) : Step()

        data class Currency(
            val options: List<CurrencyUIModel>
        ) : Step()

        data object Congrats : Step()
    }
}